import { ApplicationInsights, BaseTelemetryPlugin } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APP_INSIGHTS_URI,
    extensions: [reactPlugin as unknown as BaseTelemetryPlugin],
    extensionConfig: {},
  },
});
appInsights.loadAppInsights();

export { reactPlugin, appInsights };
